import isPromise from 'is-promise';
// import { logout } from '../actions';

const apiMiddleware = ({ dispatch, getState }) => next => action => {
const { type, payload, property } = action;

  if (!isPromise(payload)) {
    return next(action);
  }

  dispatch({ type: `${type}_PENDING` });
  return payload
  .then(response => {
    dispatch({ type: `${type}_FULFILLED`, data: response.data, property });
  })
  .catch(error => {
    const status = error && error.response && error.response.status;
    if (action.type !== 'LOGOUT' && status === 401) {
      dispatch({ type: 'LOGOUT' });
      throw error;
    }
    const errData = error && error.response && error.response.data;
    dispatch({ type: `${type}_REJECTED`, error: errData || 'ERROR', property });
  });
}

export default apiMiddleware;
